module.exports = __webpack_public_path__ + "img/act-aqua-pipe-sm.3679ee63.svg";